import React from "react";
import Flippy, { FrontSide, BackSide } from "react-flippy";

function Card(props) {
  const { onFrontClicked, flipped, info, frontFace, backFace, matched, index } =
    props;
  return (
    <div className={!matched ? "OraderItem" : "OraderItem jello-horizontal"}>
      <Flippy
        flipOnHover={false}
        flipOnClick={false}
        isFlipped={flipped}
        flipDirection="horizontal"
        style={{ width: "100%", height: "100%" }}
      >
        <FrontSide
          style={{
            backgroundImage: `url(${frontFace})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
          onClick={() => {
            onFrontClicked(index, info.id);
          }}
        />
        <BackSide
          style={{
            backgroundImage: `url(${backFace})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "28px",
          }}
        >
          <img
            src={info.image}
            alt={info.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </BackSide>
      </Flippy>
    </div>
  );
}

export default Card;
